import React, { useState } from 'react'; //, useMemo
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Form, Space, Row, Input } from 'antd'; // message,, Typography
import styles from './index.module.less';
import FormItem from 'common/FormItem';
//import CustomButton from '@/common/CustomButton';
import { history } from '@/app/history';
import { create_ro_master } from '../../../../redux/slice';
//import { debounce } from 'lodash';
import FormData from 'form-data';

//const { TextArea } = Input;
//const { Option } = Select;

function CreateROMasterFlows() {
  TabTitle('Gift Register - Create New Delegator Flow');

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const [formValues, setFormValues] = useState({});
  //const [allUsersSearch, setAllUsersSearch] = useState('');

  const { create_ro_masterLoading } = useSelector((state) => state.admin);

  /*  useEffect(() => {
    const payload = {};
    if (allUsersSearch) payload['search'] = allUsersSearch;
    dispatch(get_all_users(payload));
  }, [allUsersSearch]); */

  /* const debounceFetcherUserId = useMemo(() => {
    const loadOptions = (allUsersSearch) => {
      setAllUsersSearch(allUsersSearch);
    };
    return debounce(loadOptions, 400);
  }, []); */

  const handleFormDataOnChange = (slug, value) => {
    console.log('slug,value:', slug, value);

    setFormValues({
      ...formValues,
      [slug]: value
    });
  };

  const onFinish = (values) => {
    let formdata = new FormData();
    formdata.append(
      'locationName',
      values?.locationName === undefined ? '' : values?.locationName
    );

    formdata.append(
      'locationAddress',
      values?.locationAddress === undefined ? '' : values?.locationAddress
    );
    //formdata.append('isActive', true);

    dispatch(create_ro_master(formdata)).then(function (response) {
      if (response?.payload?.success) {
        console.log(response);
        history.push('/ro-master-flow');
      }
    });
  };

  return (
    <CustomLayout>
      {/*  <Spin spinning={get_all_usersLoading}> */}
      <div style={{ marginTop: '50px' }}>
        <Row className={`${styles.row_container_setting}`}>
          <div className={`${styles.gift_container}`}>
            <div className={`${styles.myGift_title_setting}`}>
              Add new RO Location
            </div>
          </div>
        </Row>{' '}
        <div className={`${styles.container}`}>
          <div className={`${styles.cardContainer}`}>
            <Card className={`${styles.cardStyles_Container}`}>
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                className={`${styles.formstyles}`}
              >
                <Card className={`${styles.cardStyles}`}>
                  <div className={`${styles.card_content}`}>
                    <FormItem
                      label={
                        <div className={`${styles.card_title}`}>
                          Enter the Location
                        </div>
                      }
                      name="locationName"
                      rules={[
                        {
                          required: true,
                          message: 'This is a required field'
                        }
                      ]}
                      className={`${styles.select_styles}`}
                    >
                      <Input
                        className={`${styles.margin_Top}`}
                        allowClear
                        placeholder="Enter the Location"
                        onChange={(e) =>
                          handleFormDataOnChange('locationName', e.target.value)
                        }
                      />
                    </FormItem>
                  </div>
                </Card>

                <Card className={`${styles.cardStyles}`}>
                  <div className={`${styles.card_content}`}>
                    <FormItem
                      label={
                        <div className={`${styles.card_title}`}>
                          Enter the Location Address
                        </div>
                      }
                      name="locationAddress"
                      rules={[
                        {
                          required: true,
                          message: 'This is a required field'
                        }
                      ]}
                      className={`${styles.select_styles}`}
                    >
                      <Input
                        className={`${styles.margin_Top}`}
                        allowClear
                        placeholder="Enter the Location Address"
                        onChange={(e) =>
                          handleFormDataOnChange(
                            'locationAddress',
                            e.target.value
                          )
                        }
                      />
                    </FormItem>
                  </div>
                </Card>

                <div style={{ marginTop: '20px' }}>
                  <FormItem>
                    <Space
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        justifyItems: ' center'
                      }}
                    >
                      <Button
                        loading={create_ro_masterLoading}
                        className={`${styles.ExceptionalApproval_button}`}
                        htmlType="submit"
                        size="small"
                      >
                        Save
                      </Button>

                      <Button
                        className={`${styles.cancel_rejectModal_button}`}
                        size="small"
                        onClick={() => history.push('/ro-master-flow')}
                      >
                        Cancel
                      </Button>
                    </Space>
                  </FormItem>
                </div>
              </Form>
            </Card>
          </div>
        </div>
      </div>
      {/*   </Spin> */}
    </CustomLayout>
  );
}
export default CreateROMasterFlows;
